"use client";

import Link from "next/link";

export default function NotFound() {
    return (
        <div className="flex min-h-full items-center justify-center bg-[#FFFFFF] px-4 py-8">
            <div className="flex flex-col items-center text-center">
                <img
                    src="/images/404.svg"
                    alt="404 Page Not Found"
                    className="mb-8 w-full max-w-[694px]"
                />
                <h1 className="text-[26px] font-bold leading-tight tracking-[-0.01em] text-[#111111] mb-2">
                    Page Not Found
                </h1>
                <p className="text-[16px] font-medium text-[#868A8B] mb-6 max-w-[349px] leading-[22px]">
                    We're sorry, the page you requested could not be found. Please go back to the homepage
                </p>
                <Link
                    href="/"
                    className="inline-flex items-center justify-center rounded-full bg-[#24828d] px-[30px] py-[13px] text-[14px] font-bold text-white transition-colors hover:bg-[#1f7079]"
                >
                    Go Home
                </Link>
            </div>
        </div>
    );
}
